import { Component, Input } from '@angular/core';
import { Invoice } from '../../models/invoice';

@Component({
	selector: 'app-invoice-totals',
	templateUrl: 'invoice-totals.template.html'
})

/**
 * Component that shows an invoices' total prices
 */
export class InvoiceTotalsComponent
{
	get invoice(): Invoice
	{
		return this._invoice;
	}

	@Input()
	set invoice(invoice: Invoice)
	{
		this._invoice = invoice;
		this.updateTotals(invoice);
	}

	_invoice: Invoice;
	totalExVat: number;
	totalVat: number;
	totalIncVat: number;

	/**
	 * Updates the totals with the given Invoice object
	 *
	 * @param {Invoice} invoice
	 *
	 * @return void
	 */
	updateTotals(invoice: Invoice)
	{
		this.totalExVat = 0;
		this.totalVat = 0;
		this.totalIncVat = 0;

		invoice.invoiceLines.forEach(invoiceLine => {
			this.totalExVat += invoiceLine.price_ex_vat;
			this.totalVat += invoiceLine.price_ex_vat * invoiceLine.vat_percentage / 100;
		});

    this.totalIncVat += this.totalExVat + this.totalVat;
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-detail/invoice-totals.component.ts